// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const Stolen = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `Stolen-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 18}
      height={size ?? 18}
      fill="none"
      viewBox="0 0 18 18"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${instanceId}-Stolen_a)`}>
        <path
          stroke="currentColor"
          strokeLinecap="square"
          strokeLinejoin="round"
          d="M10.246 16.088c-.395-.29-.737-.458-1.246-.458-.51 0-.851.169-1.246.458"
        />
        <path
          stroke="currentColor"
          d="M3.78 6.709v-.533c0-2.684 2.789-4.458 5.22-3.32 2.43-1.139 5.22.636 5.22 3.32v.533l2.413 1.965H1.367zM7.972 13.412c-.68.278-1.438.454-1.956.454-2.526 0-3.472-1.394-3.541-3.24V8.675c2.072.12 10.982.023 13.05.028l-.016 1.925c-.003 1.882-.967 3.24-3.501 3.24-.562 0-1.228-.16-1.896-.455-1.03-.454-1.03-.454-2.14 0Z"
        />
        <path
          fill="currentColor"
          d="M12.126 11.845c.916-.008 1.456-.727 1.456-1.896 0 0-3.399-.058-3.399 1.888zM5.875 11.837c-.917-.008-1.457-.727-1.457-1.896 0 0 3.399-.058 3.399 1.888z"
        />
      </g>
      <defs>
        <clipPath id={`${instanceId}-Stolen_a`}>
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(Stolen);
export default ForwardRef;
